import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { WorldIcon } from 'images'

import ManageIntegrations from 'components/DataIntegrations/ManageIntegrations'
import DataIntegrationsProvider from 'components/DataIntegrations/DataIntegrationsProvider'

function DataIntegrationsContent() {
  const { t, i18n } = useTranslation()

  const supportArticleUrl =
    i18n.language === 'en'
      ? 'https://support.future-demand.com/how-to-use-the-integration-with-starmate-and-brevo'
      : 'https://support.future-demand.com/de/how-to-use-the-integration-with-starmate-and-brevo'

  return (
    <div className="settings-page__sectionBody">
      <div className="settings-page__sectionColumn w-100">
        <div className="settings-page__sectionIcon">
          <WorldIcon width={17} />
        </div>
        <div className="settings-page__sectionWrapper">
          <div className="settings-page__sectionState flex-wrap">
            <h3 className="settings-page__sectionTitle">
              {t('Settings.system.integrations.title')}
            </h3>
            <p className="settings-page__sectionValue d-block">
              <Trans
                i18nKey="Settings.system.integrations.description"
                components={{
                  a: (
                    <a
                      href={supportArticleUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: 'inline-block', color: '#2F80ED' }}
                    >
                      Support article
                    </a>
                  ),
                }}
              />
            </p>
          </div>
          <ManageIntegrations />
        </div>
      </div>
    </div>
  )
}

export default function DataIntegrations() {
  return (
    <DataIntegrationsProvider>
      <DataIntegrationsContent />
    </DataIntegrationsProvider>
  )
}
